import { render, staticRenderFns } from "./coinExchange.vue?vue&type=template&id=660683dd&"
import script from "./coinExchange.vue?vue&type=script&lang=js&"
export * from "./coinExchange.vue?vue&type=script&lang=js&"
import style0 from "./coinExchange.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports